var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1491_5827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 37
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.40332,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1491_5827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.35 31.9032L20.1375 23.6907L23.2875 20.5407L31.5 28.7532L28.35 31.9032ZM7.65 31.9032L4.5 28.7532L14.85 18.4032L12.3 15.8532L11.25 16.9032L9.3375 14.9907V18.0657L8.2875 19.1157L3.75 14.5782L4.8 13.5282H7.875L6 11.6532L11.325 6.32822C11.825 5.82822 12.3625 5.46572 12.9375 5.24072C13.5125 5.01572 14.1 4.90322 14.7 4.90322C15.3 4.90322 15.8875 5.01572 16.4625 5.24072C17.0375 5.46572 17.575 5.82822 18.075 6.32822L14.625 9.77822L16.5 11.6532L15.45 12.7032L18 15.2532L21.375 11.8782C21.275 11.6032 21.1938 11.3157 21.1313 11.0157C21.0688 10.7157 21.0375 10.4157 21.0375 10.1157C21.0375 8.64072 21.5438 7.39697 22.5563 6.38447C23.5688 5.37197 24.8125 4.86572 26.2875 4.86572C26.6625 4.86572 27.0188 4.90322 27.3563 4.97822C27.6938 5.05322 28.0375 5.16572 28.3875 5.31572L24.675 9.02822L27.375 11.7282L31.0875 8.01572C31.2625 8.36572 31.3812 8.70947 31.4437 9.04697C31.5063 9.38447 31.5375 9.74072 31.5375 10.1157C31.5375 11.5907 31.0313 12.8345 30.0188 13.847C29.0063 14.8595 27.7625 15.3657 26.2875 15.3657C25.9875 15.3657 25.6875 15.3407 25.3875 15.2907C25.0875 15.2407 24.8 15.1532 24.525 15.0282L7.65 31.9032Z",
    fill: "#000E4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.2f711c78cf777b68c37f0f05b6d4cbe9.svg";
export { ForwardRef as ReactComponent };